<template>
  <v-fade-transition mode="out-in">
    <v-app>
      <core-app-bar />

      <core-drawer />

      <core-view />

      <!--     <core-footer /> -->
      <notify />
      <confirm ref="confirm" />
    </v-app>
  </v-fade-transition>
</template>

<script>
  import Notify from './../../UIComponents/Notify'
  import Confirm from './../../UIComponents/Confirm'
  import Drawer from './Drawer'
  import AppBar from './AppBar'
  import View from './View'
  export default {
    components: {
      Notify,
      Confirm,
      CoreDrawer: Drawer,
      /* CoreFooter: () => import('./Footer.vue'), */
      CoreAppBar: AppBar,
      CoreView: View,
    },
  }
</script>

<style lang="scss">
</style>
